import {
  CHANGE_PASSWORD_TOKEN_KEY,
  PENDING_CHANGE_PWD_EMAIL_KEY,
  PENDING_CHANGE_PWD_OLD_KEY,
  REFRESH_TOKEN_KEY,
  TOKEN_KEY,
} from '@/utils/constants'

export const checkHaveToken = () => !!getToken()

export const checkHaveChangePasswordToken = () => !!getChangePasswordToken()

// Use localStorage so the token is shared across tabs (e.g. opening user detail in a new tab stays logged in)
export const getToken = () => (typeof localStorage !== 'undefined' ? localStorage.getItem(TOKEN_KEY) : null)

export const setToken = token => { if (typeof localStorage !== 'undefined') localStorage.setItem(TOKEN_KEY, token) }

export const getChangePasswordToken = () => (
  typeof localStorage !== 'undefined' ? localStorage.getItem(CHANGE_PASSWORD_TOKEN_KEY) : null
)

export const setChangePasswordToken = token => {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(CHANGE_PASSWORD_TOKEN_KEY, token)
  }
}

export const clearChangePasswordToken = () => {
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(CHANGE_PASSWORD_TOKEN_KEY)
  }
}

export const setPendingChangePwdOld = password => {
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.setItem(PENDING_CHANGE_PWD_OLD_KEY, password)
  }
}

export const getPendingChangePwdOld = () => (
  typeof sessionStorage !== 'undefined' ? sessionStorage.getItem(PENDING_CHANGE_PWD_OLD_KEY) : null
)

export const clearPendingChangePwdOld = () => {
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.removeItem(PENDING_CHANGE_PWD_OLD_KEY)
  }
}

export const setPendingChangePwdEmail = email => {
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.setItem(PENDING_CHANGE_PWD_EMAIL_KEY, email)
  }
}

export const getPendingChangePwdEmail = () => (
  typeof sessionStorage !== 'undefined' ? sessionStorage.getItem(PENDING_CHANGE_PWD_EMAIL_KEY) : null
)

export const clearPendingChangePwdEmail = () => {
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.removeItem(PENDING_CHANGE_PWD_EMAIL_KEY)
  }
}

export const clearPendingChangePwdSession = () => {
  clearPendingChangePwdOld()
  clearPendingChangePwdEmail()
}

export const getRefreshToken = () => (
  typeof localStorage !== 'undefined' ? localStorage.getItem(REFRESH_TOKEN_KEY) : null
)

export const setRefreshToken = token => {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(REFRESH_TOKEN_KEY, token)
  }
}

export const clearToken = () => {
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(REFRESH_TOKEN_KEY)
    localStorage.removeItem(CHANGE_PASSWORD_TOKEN_KEY)
  }
  clearPendingChangePwdSession()
}
